import {
  Alert,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  MenuItem,
  Pagination,
  Snackbar,
  Stack,
  TextField,
  Typography
} from '@mui/material'
import React, { useEffect, useState, useRef } from 'react'
import { Helmet } from 'react-helmet-async'
import { businessCheck } from '../../utils/utils'
import { useNavigate } from 'react-router-dom'
import MainCard, {
  ErrorScreen,
  Search,
  SearchIconWrapper,
  ShowNoRecordsFound,
  SnackBarHideDuration,
  SnackBarTransition,
  StyledInputBase,
  stringAvatar
} from '../../utils/ui_utils'
import UserTypeShimmer from '../../utils/ui_components/shimmers/userTypeShimmer'
import { Search as SearchIcon } from '@mui/icons-material'
import InventoryUpdateDailog from './inventory/inventoryUpdateDailog'
import { useFetchOutlet } from '../../modules/outlet/outletHooks'
import { useFetchItems, useSearchItems } from '../../modules/items/itemsHooks'
import { useFetchKitchenCounters } from '../../modules/kitchenCounters/kitchenCountersHooks'
import {
  useFetchLatestInventory,
  useUpdateInventory
} from '../../modules/inventory/inventoryHooks'
import { useTerminalSettingsFetch } from '../../modules/terminalSettings/terminalSettingsHooks'
import _ from 'lodash'

function Inventory() {
  const jumpToInputRef = useRef(null)
  const searchInputRef = useRef(null)
  const [searchAutoFocus, setSearchAutoFocus] = useState(false)
  const [jumpAutoFocus, setJumpAutoFocus] = useState(false)
  const [shouldScrollToTop, setShouldScrollToTop] = useState(false)
  const [loading, setLoading] = useState(false)
  const [itemsError, setItemsError] = useState(false)
  const [outletError, setOutletError] = useState(false)
  const [selectedOutlet, setSelectedOutlet] = useState('')
  const [selectedOutletName, setSelectedOutletName] = useState('')
  const [outlets, setOutlets] = useState([])
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(15)
  const [pagecount, setPageCount] = useState(1)
  const [goToPageInput, setGoToPageInput] = useState('')
  const [itemsData, setItemsData] = useState([])
  const [items, setItems] = useState([])
  const [stockUpdateDialogVisibility, setStockUpdateDialogVisibility] =
    useState(false)
  const [isSearchMode, setIsSearchMode] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const [enterPressed, setEnterPressed] = useState(false)
  const [currentStock, setCurrentStock] = useState('')
  const [inventoryData, setInventoryData] = useState({})
  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)

  const { outletFetch, outletFetchData, outletFetchError, outletFetchLoading } =
    useFetchOutlet()
  const { fetchItems, fetchItemsData, fetchItemsError, fetchItemsLoading } =
    useFetchItems()
  const { searchItems, searchItemsData, searchItemsError, searchItemsLoading } =
    useSearchItems()
  const { kitchenCountersData, kitchenCountersFetch } =
    useFetchKitchenCounters()
  const { fetchLatestInventoryHook, fetchLatestInventoryData } =
    useFetchLatestInventory()
  const { updateInventory } = useUpdateInventory()
  const { terminalSettingsFetch, terminalSettingsFetchData } =
    useTerminalSettingsFetch()

  const history = useNavigate()

  const handleOutletChange = (event) => {
    setItemsData([])
    setSelectedOutlet(event.target.value)
    outlets.map((outlet) => {
      if (outlet.id == event.target.value) {
        setSelectedOutletName(outlet.name)
        return
      }
    })

    fetchItemsAndKitchenCountersOnOutletChange(event.target.value)
  }

  const fetchOutletOnError = () => {
    let payload = {
      pageNumber: 1,
      limit: 100
    }
    outletFetch(payload)
  }

  const fetchItemsAndKitchenCountersOnOutletChange = (outletId) => {
    setPage(1)
    let payload = {
      outlet_id: outletId,
      pageNumber: 1,
      limit: 100
    }
    kitchenCountersFetch(payload)
    payload.limit = limit
    payload.onlyInventoryItems = true
    fetchItems(payload)
    terminalSettingsFetch(outletId)
  }

  const pageCount = (data1) => {
    if (data1 == 0) {
      setPageCount(0)
    } else {
      let count = Math.ceil(data1 / limit)
      setPageCount(count)
    }
  }

  const handlePageChange = async (event, value) => {
    setPage(value)
    if (isSearchMode) {
      let payload = {
        outlet_id: selectedOutlet,
        pageNumber: 1,
        limit: limit,
        searchQuery: searchQuery,
        onlyInventoryItems: true
      }
      searchItems(payload)
    } else {
      let payload = {
        outlet_id: selectedOutlet,
        pageNumber: value,
        limit: limit,
        onlyInventoryItems: true
      }
      fetchItems(payload)
    }
  }

  const handleGoToPageChange = (event) => {
    const value = event.target.value
    if (/^\d+$/.test(value) || value === '') {
      setGoToPageInput(value)
    }
  }

  const handleGoToPageSubmit = () => {
    const pageNum = parseInt(goToPageInput, 10)
    if (pageNum >= 1 && pageNum <= pagecount) {
      handlePageChange(null, pageNum)
      setGoToPageInput('')
      // Trigger scroll to top
      setShouldScrollToTop(true)
    }
  }

  const handleGoToPageKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      event.stopPropagation()
      handleGoToPageSubmit()
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && searchQuery) {
      setPage(1)
      setIsSearchMode(true)
      setEnterPressed(true)
      if (selectedOutlet) {
        let payload = {
          outlet_id: selectedOutlet,
          pageNumber: 1,
          limit: limit,
          searchQuery: searchQuery,
          onlyInventoryItems: true
        }
        searchItems(payload)
      }
    }
  }

  const handleChange = (e) => {
    setSearchQuery(e.target.value)
    setEnterPressed(false)
    if (e.target.value == '') {
      setPage(1)
      setIsSearchMode(false)
      setEnterPressed(false)
      if (
        selectedOutlet != null &&
        selectedOutlet != undefined &&
        selectedOutlet != ''
      ) {
        let payload = {
          outlet_id: selectedOutlet,
          pageNumber: 1,
          limit: limit,
          onlyInventoryItems: true
        }
        fetchItems(payload)
      }
    }
  }

  const handleSnackbarClose = () => {
    setSnackBar(false)
  }

  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }

  useEffect(() => {
    businessCheck(history)
    let payload = {
      pageNumber: 1,
      limit: 100
    }
    outletFetch(payload)
  }, [])

  useEffect(() => {
    if (outletFetchData.data?.length > 0) {
      setOutlets(outletFetchData.data)
      setSelectedOutlet(outletFetchData.data[0]._id)
      setSelectedOutletName(outletFetchData.data[0].name)
      let payload = {
        outlet_id: outletFetchData.data[0]._id,
        pageNumber: 1,
        limit: 100
      }
      kitchenCountersFetch(payload)
      payload.pageNumber = page
      payload.limit = limit
      payload.onlyInventoryItems = true
      fetchItems(payload)
      terminalSettingsFetch(outletFetchData.data[0]._id)
    } else {
      setOutlets([])
      setSelectedOutlet('')
      setSelectedOutletName('')
    }
  }, [outletFetchData])

  useEffect(() => {
    if (fetchItemsData.data?.length > 0) {
      setItemsData(fetchItemsData.data)
      pageCount(fetchItemsData.total)
      // Scroll to top if triggered by Go button
      if (shouldScrollToTop) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        setShouldScrollToTop(false)
        setJumpAutoFocus(false)
        setSearchAutoFocus(true)
        setTimeout(() => {
          if (searchInputRef.current) {
            searchInputRef.current.focus()
          }
        }, 500)
      }
    } else {
      setItemsData([])
      pageCount(0)
    }
  }, [fetchItemsData])

  useEffect(() => {
    if (searchItemsData.data?.length > 0) {
      setItemsData(searchItemsData.data)
      setIsSearchMode(true)
      pageCount(searchItemsData.total)
      // Scroll to top if triggered by Go button
      if (shouldScrollToTop) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
        setShouldScrollToTop(false)
        setJumpAutoFocus(false)
        setSearchAutoFocus(true)
        setTimeout(() => {
          if (searchInputRef.current) {
            searchInputRef.current.focus()
          }
        }, 500)
      }
    } else {
      setItemsData([])
      pageCount(0)
    }
  }, [searchItemsData])

  const ListItemsUI = () => (
    <Grid container spacing={10} sx={{ paddingTop: 5 }}>
      <Grid item xs sm md>
        <Box sx={{ margin: 2 }}>
          <Card raised sx={{ borderRadius: 3 }}>
            <CardContent>
              <MainCard sx={{ width: 250 }}>
                <Search>
                  <SearchIconWrapper>
                    <SearchIcon />
                  </SearchIconWrapper>
                  <StyledInputBase
                    inputRef={searchInputRef}
                    placeholder="Search Item by Name or SKU"
                    inputProps={{
                      'aria-label': 'search'
                    }}
                    autoFocus={searchAutoFocus}
                    value={searchQuery}
                    onFocus={(e) => {
                      setSearchAutoFocus(true)
                      setJumpAutoFocus(false)
                      const scrollPos = window.pageYOffset
                      requestAnimationFrame(() => {
                        window.scrollTo(0, scrollPos)
                      })
                    }}
                    onKeyDown={(e) => {
                      const scrollPos = window.pageYOffset
                      e.stopPropagation()
                      handleKeyDown(e)
                      requestAnimationFrame(() => {
                        window.scrollTo(0, scrollPos)
                      })
                    }}
                    onChange={(e) => {
                      const scrollPos = window.pageYOffset
                      e.stopPropagation()
                      handleChange(e)
                      window.scrollTo(0, scrollPos)
                    }}
                    onInput={(e) => {
                      const scrollPos = window.pageYOffset
                      requestAnimationFrame(() => {
                        window.scrollTo(0, scrollPos)
                      })
                    }}
                  />
                </Search>
              </MainCard>
              <Grid
                container
                columns={6}
                rowSpacing={3}
                columnSpacing={3}
                mt={1}
              >
                {(!outletFetchLoading ||
                  !fetchItemsLoading ||
                  !searchItemsLoading) &&
                  itemsData?.length > 0 &&
                  itemsData?.map((items, index) => {
                    let item = _.cloneDeep(items)
                    item.kitchen_counter_id = item?.kitchen_counter?._id
                    return (
                      <Grid item xs={6} sm={3} md={2} key={index}>
                        <MainCard
                          key={index}
                          sx={{
                            mt: 1,
                            p: 2,
                            alignItems: 'center',
                            transition: 'box-shadow 0.3s ease',
                            borderRadius: 1,
                            '&:hover': {
                              boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
                              backgroundColor: 'rgba(0, 0, 0, 0.04)'
                            }
                          }}
                        >
                          <Grid container spacing={1}>
                            <Grid
                              item
                              sx={{
                                mr: 3,
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <Avatar {...stringAvatar(item?.name)} />
                            </Grid>
                            {!terminalSettingsFetchData.inventory_status ? (
                              <Grid item md sm>
                                <Grid
                                  container
                                  sx={{ cursor: 'pointer' }}
                                  direction={'column'}
                                  onClick={() => {
                                    toastMessage(
                                      'Inventory Status is disabled',
                                      'error'
                                    )
                                  }}
                                >
                                  <Typography
                                    variant="h6"
                                    sx={{ fontWeight: 'bold' }}
                                  >
                                    {item?.name}
                                  </Typography>
                                  <Typography
                                    variant="body1"
                                    sx={{ color: 'text.secondary' }}
                                  >
                                    SKU
                                  </Typography>
                                  <Typography
                                    variant="body1"
                                    sx={{ color: 'text.secondary' }}
                                  >
                                    {item.sku || '-'}
                                  </Typography>
                                </Grid>
                              </Grid>
                            ) : (
                              <Grid item md sm>
                                <Grid
                                  container
                                  sx={{ cursor: 'pointer' }}
                                  direction={'column'}
                                  onClick={() => {
                                    setStockUpdateDialogVisibility(true)
                                    setItems(item)
                                    setInventoryData({
                                      name: item.name,
                                      stock: '',
                                      remarks: ''
                                    })
                                    let body = {
                                      id: item._id,
                                      outlet_id: selectedOutlet
                                    }
                                    fetchLatestInventoryHook(body)
                                  }}
                                >
                                  <Typography
                                    variant="h6"
                                    sx={{ fontWeight: 'bold' }}
                                  >
                                    {item?.name}
                                  </Typography>
                                  <Typography
                                    variant="body1"
                                    sx={{ color: 'text.secondary' }}
                                  >
                                    SKU
                                  </Typography>
                                  <Typography
                                    variant="body1"
                                    sx={{ color: 'text.secondary' }}
                                  >
                                    {item.sku || '-'}
                                  </Typography>
                                </Grid>
                              </Grid>
                            )}
                          </Grid>
                        </MainCard>
                      </Grid>
                    )
                  })}
              </Grid>
            </CardContent>
            {pagecount > 1 && (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                  p: 2,
                  backgroundColor: 'grey.50',
                  borderRadius: 1
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%'
                  }}
                >
                  <Pagination
                    count={pagecount}
                    page={page}
                    color="secondary"
                    size="small"
                    boundaryCount={2}
                    siblingCount={0}
                    showFirstButton
                    showLastButton
                    onChange={handlePageChange}
                    sx={{
                      '& .MuiPaginationItem-root': {
                        transition: 'all 0.2s ease-in-out'
                      }
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 1.5,
                    backgroundColor: 'white',
                    p: 2,
                    borderRadius: 1,
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                    transition: 'box-shadow 0.2s ease-in-out',
                    '&:hover': { boxShadow: '0 2px 6px rgba(0,0,0,0.12)' }
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ color: 'text.secondary', fontWeight: 500 }}
                  >
                    Jump to
                  </Typography>
                  <TextField
                    inputRef={jumpToInputRef}
                    size="small"
                    autoFocus={jumpAutoFocus}
                    value={goToPageInput}
                    onFocus={(e) => {
                      setJumpAutoFocus(true)
                      setSearchAutoFocus(false)
                      const scrollPos = window.pageYOffset
                      requestAnimationFrame(() => {
                        window.scrollTo(0, scrollPos)
                      })
                    }}
                    onChange={(e) => {
                      const scrollPos = window.pageYOffset
                      e.stopPropagation()
                      handleGoToPageChange(e)
                      window.scrollTo(0, scrollPos)
                    }}
                    onKeyPress={(e) => {
                      const scrollPos = window.pageYOffset
                      e.stopPropagation()
                      handleGoToPageKeyPress(e)
                      window.scrollTo(0, scrollPos)
                    }}
                    placeholder="Page"
                    onKeyDown={(e) => {
                      const scrollPos = window.pageYOffset
                      e.stopPropagation()
                      if (
                        [
                          'ArrowUp',
                          'ArrowDown',
                          'PageUp',
                          'PageDown',
                          'Home',
                          'End'
                        ].includes(e.key)
                      ) {
                        e.preventDefault()
                      }
                      requestAnimationFrame(() => {
                        window.scrollTo(0, scrollPos)
                      })
                    }}
                    onInput={(e) => {
                      const scrollPos = window.pageYOffset
                      requestAnimationFrame(() => {
                        window.scrollTo(0, scrollPos)
                      })
                    }}
                    inputProps={{
                      style: { textAlign: 'center' }
                    }}
                    sx={{
                      width: '80px',
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: 'white',
                        transition: 'all 0.2s ease-in-out',
                        '& fieldset': {
                          borderColor: 'grey.300',
                          borderWidth: '1px'
                        },
                        '&:hover fieldset': {
                          borderColor: 'secondary.main',
                          borderWidth: '1.5px'
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'secondary.main',
                          borderWidth: '2px',
                          boxShadow: '0 0 0 3px rgba(156, 39, 176, 0.1)'
                        }
                      },
                      '& .MuiOutlinedInput-input': {
                        textAlign: 'center',
                        fontWeight: 500,
                        padding: '7px 8px',
                        height: '20px',
                        lineHeight: '20px'
                      }
                    }}
                  />
                  <Typography
                    variant="body2"
                    sx={{ color: 'text.secondary', fontWeight: 400 }}
                  >
                    of {pagecount}
                  </Typography>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={(e) => {
                      e.preventDefault()
                      handleGoToPageSubmit()
                    }}
                    onMouseDown={(e) => e.preventDefault()}
                    disableFocusRipple
                    disabled={
                      !goToPageInput ||
                      parseInt(goToPageInput, 10) < 1 ||
                      parseInt(goToPageInput, 10) > pagecount
                    }
                    sx={{
                      textTransform: 'none',
                      fontWeight: 500,
                      px: 2,
                      py: 0.75,
                      height: '34px',
                      lineHeight: 1,
                      transition: 'all 0.2s ease-in-out',
                      '&:hover': {
                        transform: 'translateY(-1px)',
                        boxShadow: '0 4px 8px rgba(156, 39, 176, 0.3)'
                      },
                      '&:active': { transform: 'translateY(0)' }
                    }}
                  >
                    Go
                  </Button>
                </Box>
              </Box>
            )}
          </Card>
        </Box>
      </Grid>
    </Grid>
  )

  return (
    <>
      <Helmet title="Inventory" />
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Grid item xs={9}>
          <Typography variant="h4" gutterBottom>
            Inventory
          </Typography>
        </Grid>
      </Grid>
      <Divider sx={{ mt: 5 }} />
      {outletFetchError ? (
        <ErrorScreen
          onClick={() => {
            fetchOutletOnError()
          }}
        />
      ) : (
        <div>
          <Grid container spacing={6}>
            <Grid item md={3}>
              <TextField
                size="small"
                label="Outlet"
                id="outlet"
                name="outlet"
                variant="outlined"
                margin="normal"
                value={selectedOutlet}
                onChange={handleOutletChange}
                select
                fullWidth
              >
                {outlets.map((outlet) => (
                  <MenuItem key={outlet._id} value={outlet._id}>
                    {outlet.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
          {!isSearchMode ? (
            <>
              {fetchItemsError || searchItemsError ? (
                <ErrorScreen
                  onClick={() => {
                    setItemsError(false)
                  }}
                />
              ) : (
                <>
                  {(outletFetchLoading ||
                    fetchItemsLoading ||
                    searchItemsLoading) && (
                    <UserTypeShimmer shimmerCount={[1, 3, 5]} />
                  )}
                  {!outletFetchLoading &&
                    !fetchItemsLoading &&
                    !searchItemsLoading &&
                    itemsData?.length > 0 && <ListItemsUI />}
                  {!outletFetchLoading &&
                    !fetchItemsLoading &&
                    !searchItemsLoading &&
                    itemsData?.length === 0 && <ShowNoRecordsFound />}
                </>
              )}
            </>
          ) : (
            <ListItemsUI />
          )}
        </div>
      )}
      <InventoryUpdateDailog
        visibility={stockUpdateDialogVisibility}
        initialValues={inventoryData}
        currentStock={fetchLatestInventoryData.data?.balance}
        onSubmit={async (values) => {
          let body = {
            item_id: items._id,
            quantity: values.stock,
            warehouse_id: selectedOutlet,
            remarks: values.remarks
          }
          await updateInventory(body, (success, error, res) => {
            if (success) {
              let payload = {
                outlet_id: selectedOutlet,
                pageNumber: 1,
                limit: limit,
                onlyInventoryItems: true
              }
              fetchItems(payload)
              setStockUpdateDialogVisibility(false)
              toastMessage(res, 'success')
              setCurrentStock('')
            } else {
              toastMessage(res, 'error')
            }
          })
        }}
        onClose={() => {
          setStockUpdateDialogVisibility(false)
          setCurrentStock('')
        }}
      />
      <Snackbar
        open={snackbar}
        autoHideDuration={SnackBarHideDuration}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={handleSnackbarClose}
        TransitionComponent={SnackBarTransition}
      >
        <Alert onClose={handleSnackbarClose} severity={severity}>
          {PopUpMessage}
        </Alert>
      </Snackbar>
    </>
  )
}

export default Inventory
